<template>
    <main>
        <header class="banner solutions edu-solution">
            <div class="container">
                <div class="text-left">
                    <router-link tag="a" to="/solucoes" class="btn btn-viitra-green"><i class="fas fa-chevron-left"></i> Back to solutions</router-link>
                </div>
                <h1>Educational Solutions</h1>
                <h4>for high impact business</h4>
            </div>
            <div class="clip-path-one green70">
                <span class="arrow-header"></span>
            </div>
        </header>

        <section class="solution-intro">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 offset-md-2">
                        Our learning solutions are optimized for your business strategic goals. We produce a variety of types of media from eBooks to learning game,  videos,  online classes and  infographic. Besides that, we create or adapt all the content involved so it is possible to transform the learning processes into something more light and dynamic.
                    </div>
                </div>
            </div>
        </section>

        <section class="solution-items">

            <solution-item v-for="(item, i) of data.solutionItems" :data="item" :number="i + 1" :key="i"></solution-item>

        </section>

        <section class="parallax edu-solution"></section>

    

        <section class="cta-solutions">
            <div class="container">
                <div class="row">
                    <div class="col-md-3">
                        <router-link tag="a" to="/solucoes" class="btn btn-viitra-green"><i class="fas fa-chevron-left"></i> Back to Solutions</router-link>
                    </div>
                    <div class="col-md-6">
                        <h1>want to see<br>more solutions?</h1>
                    </div>
                    <div class="col-md-3">
                        <router-link tag="a" to="/solucoes/gestao-de-estagios" class="btn btn-viitra-dark">Go to Energy Labelling<i class="fas fa-chevron-right"></i></router-link>
                    </div>
                </div>
            </div>
            <div class="path opacity40"></div>
            <div class="path opacity60"></div>
            <div class="path opacity80"></div>
        </section>
        
        <section class="cta-solutions mobile">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1>want to see<br>more solutions?</h1>
                    </div>
                    <div class="col-md-12">
                        <router-link tag="a" to="/solucoes" class="btn btn-viitra-green"><i class="fas fa-chevron-left"></i>Back to Solutions</router-link>
                    </div>
                    <div class="col-md-12">
                        <router-link tag="a" to="/solucoes/gestao-de-estagios" class="btn btn-viitra-dark">Go to Energy Labelling <i class="fas fa-chevron-right"></i></router-link>
                    </div>
                </div>
            </div>
            <div class="path opacity40"></div>
            <div class="path opacity60"></div>
            <div class="path opacity80"></div>
        </section>
    </main>
</template>

<script>
    export default {
        data() {
            return {
                data: {
                    solutionItems: [
                        {
                            title: 'Virtual Learning Environment',
                            description: `
                                <p>A educational platform with the format and aspect of a social network which brings engagement in and out of the classroom throughout a interactive and collaborative environment where the focal point is learning.</p>
                                <p>Students and educators can answer questions, prepare exercises and share didactic material (texts, videos and books) through the system, using the many different forms of interactions that only a social networking can provide.</p>
                            `,
                            imageArea: {
                                type: 'gallery',
                                images: [
                                    {
                                        src: '/static/images/solutions/educational/carousel-openredu/1.png',
                                        caption: 'Aula multimídia'
                                    },
                                    {
                                        src: '/static/images/solutions/educational/carousel-openredu/2.png',
                                        caption: 'Mural de discussão'
                                    },
                                    {
                                        src: '/static/images/solutions/educational/carousel-openredu/3.png',
                                        caption: 'Banco do questões'
                                    },
                                    {
                                        src: '/static/images/solutions/educational/carousel-openredu/4.png',
                                        caption: 'Troca de mensagens'
                                    },
                                    {
                                        src: '/static/images/solutions/educational/carousel-openredu/5.png',
                                        caption: 'Emblemas conquistados'
                                    },
                                    {
                                        src: '/static/images/solutions/educational/carousel-openredu/6.png',
                                        caption: 'Leaderbord de usuários'
                                    },
                                    {
                                        src: '/static/images/solutions/educational/carousel-openredu/7.png',
                                        caption: 'Atualizações no mural'
                                    },
                                    {
                                        src: '/static/images/solutions/educational/carousel-openredu/8.png',
                                        caption: 'Ferramentas de acessibilidade'
                                    },
                                ]
                            },
                            topics: [
                                {title: 'Organization of different digital medias'},
                                {title: 'Interaction between users'},
                                {title: 'Gamification system'},
                                {title: 'Learning monitoring'},
                                {title: 'Questions bank'},
                                {title: 'Visualization and exportation of the management reports'},
                                {title: 'Customization and visual identity'},
                                {title: 'Simplicity of the usage and formation'},
                                {title: 'Tools for accessibility'},
                                {title: 'Application for Android and iOS'},
                            ]
                        },
                        {
                            title: 'Producing Content ',
                            description: `
                                <p>There are multiples difficulties within the numerous processes that involves the e-learning field so that the educational material can be created and available to the student.  Our pedagogical team is composed of specialized masters and doctors who participates in the creation of these types of content.</p>
                            `,
                            imageArea: {
                                type: 'image',
                                src: '/static/images/solutions/educational/edu-figure-5.jpg'
                            },
                        },
                        {
                            title: 'Content Transposition',
                            description: `
                                <p>We are experts in convert traditional educational programs (with didactic material  in books and powerpoints) into e-Learning format, which is more exclusive and interactive. Our concern is with the instructional perspective and the conception of contents before transposing the traditional educational programs to the digital format.</p>
                            `,
                            imageArea: {
                                type: 'image',
                                src: '/static/images/solutions/educational/edu-figure-2.jpg'
                            },
                        },
                        {
                            title: 'Training for Tutors and Mediators',
                            description: `
                                <p>We develop in all participants competences associated with the the distance education teaching format, such as familiarity with the Virtual Learning Environment, motivation abilities, student support, as well as the practice of mediation throughout the classes.</p>
                            `,
                            imageArea: {
                                type: 'image',
                                src: '/static/images/solutions/educational/edu-figure-9.jpg'
                            },
                        },
                        {
                            title: 'Platform for School Management',
                            description: `
                                <p>Our system for school management brings facilities and makes school management processes more efficient for the education secretariats and the school it selves. With this technology is possible to monitor all the information in real time through consultation and generated reports.</p>
                            `,
                            imageArea: {
                                type: 'gallery',
                                images: [
                                    {
                                        src: '/static/images/solutions/educational/carousel-ieducar/1.png',
                                        caption: 'Ficha cadastral do aluno'
                                    },
                                    {
                                        src: '/static/images/solutions/educational/carousel-ieducar/2.png',
                                        caption: 'Cadastro de séries'
                                    },
                                    {
                                        src: '/static/images/solutions/educational/carousel-ieducar/3.png',
                                        caption: 'Detalhes do curso'
                                    },
                                    {
                                        src: '/static/images/solutions/educational/carousel-ieducar/4.png',
                                        caption: 'Histórico escolar'
                                    },
                                    {
                                        src: '/static/images/solutions/educational/carousel-ieducar/5.png',
                                        caption: 'Quadro de horário'
                                    },
                                    {
                                        src: '/static/images/solutions/educational/carousel-ieducar/6.png',
                                        caption: 'Estrutura de cadastros'
                                    },
                                ]
                            },
                            
                        },
                        {
                            title: 'Analytics Platform',
                            description: `
                                <p>A platform with the goal to give life to educational data so it can auxiliate administrators, principals, teachers and all the interested in making better choices in education. The system contains innovative educational data analysis technologies and a modern design to facilitate the access to the information needed.</p>
                            `,
                            imageArea: {
                                type: '',
                                src: ''
                            },
                        },
                    ]
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/solutions/Edu.vue